import { render } from "./SegmentationGroup.vue?vue&type=template&id=7a13e83c&scoped=true"
import script from "./SegmentationGroup.vue?vue&type=script&lang=js"
export * from "./SegmentationGroup.vue?vue&type=script&lang=js"

import "./SegmentationGroup.vue?vue&type=style&index=0&id=7a13e83c&lang=scss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a13e83c"]])

export default __exports__